import React, { Component } from "react";
import moment from "moment-timezone";

// CSS
import "../../css/news-article.css";

class NewsContent extends Component {
	render() {
		const { news } = this.props;

		return (
			<div className="news-story">
				<h2>{news.title}</h2>
				<div className="article-date">
					{moment
						.utc(news.date_added)
						.local()
						.format("MMM DD YYYY hh:mma")}
				</div>
				<div
					className="news-story--content"
					dangerouslySetInnerHTML={{ __html: news.content }}
				/>
			</div>
		);
	}
}

export default NewsContent;



// WEBPACK FOOTER //
// ./src/components/news/NewsContent.js